
export const TxtSavingsByFees = (feeName, Saving, currencySymbol='$') => {
    return  `pagando ${feeName?.toLowerCase()}mente ahorras ${currencySymbol}${new Intl.NumberFormat('es-MX').format(Saving)}`
}